import { matchPath } from 'react-router-dom';

export const isMatchingRoute = (additionalRoutes: string[], location: string) =>
  additionalRoutes?.some((path) => matchPath(path.concat('/*'), location));
